import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import usePartnersEngagingWithEducators from './usePartnersEngagingWithEducators';
import useActivePartners from './useActivePartners';

export default function PercentPartnersEngagingWithEducators(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `% of partners engaging with educators`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousCreatedProject = usePartnersEngagingWithEducators(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newCreatedProject = usePartnersEngagingWithEducators(network, {
    start: schoolStart,
    end: schoolEnd
  });

  const previousAffiliatedNetworkSite = useActivePartners(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newAffiliatedNetworkSite = useActivePartners(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousCreatedProject.state === PayloadStates.FETCHING ||
    newCreatedProject.state === PayloadStates.FETCHING ||
    previousAffiliatedNetworkSite.state === PayloadStates.FETCHING ||
    newAffiliatedNetworkSite.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  const newPercent = Math.ceil(newCreatedProject.meta.totalCount / newAffiliatedNetworkSite.meta.totalCount * 100);
  const previousPercent = Math.ceil(previousCreatedProject.meta.totalCount / previousAffiliatedNetworkSite.meta.totalCount * 100);

  return (
    <ComparisonMetric
      name={title}
      value={newPercent}
      previousValue={previousPercent}
      titleOnly={titleOnly}
      percent={true}
    />
  );
}
